<template>
    <div class="collection-manage-box">
        <div class="collection-manage-head">
            <div class="collection-manage-condition-box">
                <el-form :inline="true" size="small">
                    <el-form-item label="集中器编号">
                        <el-input
                                class="meter-manage-condition-box-label"
                                placeholder="请输入集中器编号"
                                size="small"
                                v-model="input"
                                clearable
                                @clear="clearInput"
                                @keyup.enter.native="search()"
                                :maxlength="inputMaxLength"
                        >
                            <!--回车搜索@keyup.enter.native="search()"-->
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search()" style="margin-left: 0.5rem" size="small">查 找
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="op-box">
                <el-button type="primary" @click="modify" size="small" round><i>
                    <svg-icon style="width:1em; height: 1em" icon-class="修改"></svg-icon>
                </i>&nbsp;修 改
                </el-button>
                <el-button type="primary" @click="collectionDelete" size="small" round="" icon="el-icon-delete">删除</el-button>
                <!--
                            <el-button size="small" icon="el-icon-edit" type="text" @click="modify" style="margin-left: 3%">修改
                            </el-button>
                            <el-button type="text" icon="el-icon-delete" size="small" style="margin-left: 3%">删除</el-button>-->

            </div>

        </div>
        <div class="div-hr"></div>
        <flex>
            <el-table
                    highlight-current-row
                    :data="list"
                    id="out-table"
                    :cell-style="{padding:'0.5'}"
                    v-loading="loading"
                    @row-click="rowClick"
                    :header-row-style="{color:'black'}"
                    size="small"
                    stripe
                    height="96%"
                    width="100%"
            >
                <!--:row-class-name="tableRowClassName"
                    :row-style="selectedHighlight"-->
                <!--@row-click 当某一行被点击时会触发该事件-->
                <!--:row-class-name 设置行className之后的回调方法，也可以使用字符串为所有行设置一个固定的 className。-->
                <!--:row-style 设置自行style之后的回调方法，也可以使用一个固定的 Object 为所有行设置一样的 Style。-->

                <!--
                :row-style="cellHeight"
                style="width: 100%"
                    row-style="height:0"
                    cell-style="padding:0"-->
                <el-table-column
                        align="center"
                        prop="name"
                        label="集中器名称"
                        :formatter="tableStringFormat">
                    <!--<template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入内容"></el-input>
                    </template>可编辑表格-->
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="code"
                        label="集中器编号"
                        :formatter="tableStringFormat">
                </el-table-column>

                <!--<el-table-column
                        align="center"
                        prop="enabled"
                        label="启用状态"
                        :formatter="tableStringFormat">
                    <template slot-scope="scope">
                        <span>{{ scope.row.enabled === 1 ? '启用': '停用' }}</span>
                    </template>
                </el-table-column>-->
                <el-table-column
                        align="center"
                        label="图 标"
                        :formatter="tableStringFormat">
                    <template slot-scope="scope">
                        <i class="el-icon-picture"></i>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="status"
                        label="通信状态"
                        :formatter="tableStringFormat">
                    <template slot-scope="scope">
                        <!-- <i class="el-icon-error" v-if="scope.row.status === 0"></i>
                         <i class="el-icon-success" v-if="scope.row.status === 1"></i>-->
                        <svg-icon :icon-class="scope.row.status === 1 ? 'wifi_green' : 'wifi_red'"></svg-icon>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="note"
                        label="备注"
                        :formatter="tableStringFormat">
                </el-table-column>
            </el-table>

        </flex>

        <div v-if="this.list!== ''" class="collection-manage-page-box">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total"
                    align="center"
            >
                <!--total: Number,  总条数
                current: Number,  当前页数
                size: Number,  每页条数
                pages: Number 总页数-->
            </el-pagination>
        </div>
        <div style="display: flex; justify-content: center">

            <el-dialog title="修改集中器" :visible.sync="dialogFormVisible"
                       width="40%" @open="open" :close-on-click-modal="false" @close="resetForm('form')">


                    <el-form ref="form" :model="form" label-width="7rem"
                             v-loading="loading" :rules="myRules" size="small">
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="集中器名称" prop="name">
                                    <!--label-width设置label内容的宽度-->
                                    <el-input v-model="form.name" size="small"
                                              @blur="form.name = form.name.replace(/\s/g,'')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="集中器编号">
                                    <el-input v-model="form.code" size="small" disabled></el-input>
                                </el-form-item>
                            </el-col>


                        </el-row>
                        <el-row>
                            <!-- <el-col :span="11">
                                 <el-form-item label="是否启用" label-width="100px" prop="enabled">
                                     &lt;!&ndash;<el-radio-group v-model="form.enabled">
                                         <el-radio :label="1">启用</el-radio>
                                         <el-radio :label="0">不启用</el-radio>
                                     </el-radio-group>&ndash;&gt;
                                     <el-select v-model="form.enabled" style="width: 120px" placeholder="启用状态">
                                         <el-option label="启用" :value="1"></el-option>
                                         <el-option label="停用" :value="0"></el-option>
                                     </el-select>
                                 </el-form-item>
                             </el-col>-->
                            <el-col :span="11">
                                <el-form-item label="图 标" prop="icon">

                                    <el-select v-model="form.icon" placeholder="请选择">
                                        <el-option
                                                v-for="item in list"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-form-item label="备 注" prop="note">
                                <el-col :span="22">
                                    <el-input
                                            type="textarea"
                                            placeholder="请输入内容"
                                            v-model="form.note">
                                    </el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </el-form>

                <div slot="footer" class="dialog-footer">

                    <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="ruleForm('form')" :loading="disabled" size="small">保 存
                    </el-button>
                    <!--
                    <el-button @click="resetForm('form')" id="resetForm" size="mini">重置</el-button>-->

                </div>

            </el-dialog>
            <el-dialog :visible.sync="deleteByEntityDialogVisible" size="small">
                <template slot="title">删除集中器</template>
                <div style="display: flex; justify-content: center">
                    删除集中器后数据会永久丢失！谨慎删除！
                </div>
                <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteByEntityDialogVisible = false" size="small">取消</el-button>
                        <el-button type="primary" @click="removeCollection" size="small">确认</el-button>
                    </span>
            </el-dialog>

        </div>
    </div>

</template>

<script>
  import {selectCollection, collectionModify, deleteByEntity} from '@/api/Collection'
  import {checkNum, checkName} from '@/utils/validate'
  import Flex from "../../../../components/Flex";

  export default {
    name: 'collectionManage',
    components: {Flex},
    data() {
      return {
        loading: false, /* 加载*/
        form: {
          /* 实体对应表单数据*/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: 1,
          icon: ''
        },
        inputMaxLength: 50,
        noteMaxLength: 500,
        myRules: {
          name: [/* 正则*/
            {required: true, message: '仪表名称不能为空'}, /*
            { validator: checkName, trigger: 'change' },*/
            {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'}
          ],
          code: [
            {required: true, message: '仪表代码不能为空'},
            {validator: checkNum, trigger: 'change'}
          ],
          enabled: [
            {required: true, message: '请选择是否启用', trigger: 'change'}
          ],
          icon: [
            {required: true, message: '请选择图标', trigger: 'change'}
          ],
          note: [
            {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}
          ]
        },
        page: {}, /* 分页对象*/
        condition: {}, /* 查询条件*/

        list: [], /* 集中器数据*/
        input: null,
        dialogTableVisible: false,
        dialogFormVisible: false,
          deleteByEntityDialogVisible: false,
        disabled: false/* 按钮状态*/,
        currentRow: Number/* 选中行下标*/,
        doType: String
      }
    },
    mounted() { /* 页面初始化完成加载数据*/
      this.page.size = 10
      this.selectCollection()
    },
    methods: {
      ruleForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) this.collectionModify()
          else return false
        })
      }, tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      /* insert() {
         this.restFormData()
         this.dialogFormVisible = true
         this.doType = 'insert'
       },*/
      myCheck(...values) { /* true为空 */
        if (typeof values === undefined || values === null || values === '') return true
        let ret = true
        for (let i = 0; i < values.length; i++) {
          ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
          if (ret === false) break
        }
        return ret
      },
      modify() { /* 修改集中器信息*/
        if (this.myCheck(this.form.id)) {
          /*const h = this.$createElement
          this.$message.error({
            message: h('p', null, [
              h('span', { style: 'color: teal' }, '未选择集中器!  '),
              h('i', { style: 'color: red' }, ' 请选择要修改的集中器!')
            ])
          })*/
          this.$message({
            message: '请选择要修改的集中器!',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.dialogFormVisible = true
        this.doType = 'modify'
      },
        collectionDelete() {
            if (!this.myCheck(this.form)) {
                this.deleteByEntityDialogVisible = true
            }
            else {
                this.$message({
                    message: '请选择要删除的集中器!',
                    type: 'warning',
                    duration: 5 * 1000
                })
            }

        },
        removeCollection(){
            if (!this.myCheck(this.form)) {
                deleteByEntity(this.form).then(result => {
                    if(result.code === 200){
                        this.$message({
                            message: result.message,
                            type: 'success',
                            duration: 5 * 1000
                        })
                    }else{
                        this.$message({
                            message: result.message,
                            type: 'warning',
                            duration: 5 * 1000
                        })
                    }
                    this.deleteByEntityDialogVisible = false

                    const myPage = {page: this.page, condition: this.condition}
                    selectCollection(myPage).then(response => {
                        if (response.code === 200) {
                            let data = response.infoJson
                            this.page.total = data.total
                            //this.page.current = data.current
                            //this.page.size = data.size
                            //this.page.pages = data.pages
                            data = data.records
                            this.list = data
                        } else {
                            this.$message({
                                type: 'error',
                                message: '集中器信息查询失败,请刷新页面!',
                                duration: 5 * 1000
                            })

                        }
                    })

                })
            }
            else {
                this.$message({
                    message: '请选择要删除的仪表!',
                    type: 'warning',
                    duration: 5 * 1000
                })
            }
        },
      tableRowClassName({row, rowIndex}) {
        row.index = rowIndex
      },
      resetForm(formName) {
        this.restFormData()
        this.$refs[formName].resetFields()
      },
      open() { /* 点击改变按钮状态*/
        this.disabled = false
      },
      reset() { /* 重置查询条件*/
        this.page = {}
        this.condition = {}
      },
      search() { /* 模糊查询*/
        this.form = {
          /* 实体对应表单数据*/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: 1,
          icon: ''
        }
        if (this.myCheck(this.input)) return
        this.condition = {}
        this.condition.id = this.input
        this.page = {}
        this.page.size = 10
        this.selectCollection()
      },
      selectCollection() { /* 查询*/
        this.currentRow = ''
        //if (this.page.total) this.page.total = null
        const newPage = JSON.parse(JSON.stringify(this.page))
        newPage.total = null
        this.loading = true
        this.condition.customerId = this.$store.getters.customerId
        console.log(this.condition)
        const myPage = {page: this.page, condition: this.condition}
        selectCollection(myPage).then(response => {
          if (response.code === 200) {
            console.log(response)
            let data = response.infoJson
            console.log('总条数 = ' + data.total + '  当前页数 = ' + data.current + '  每页条数 ' + data.size)
            this.page.total = data.total
            // this.page.current = data.current
            // this.page.size = data.size
            // this.page.pages = data.pages
            data = data.records
            this.list = data

            console.log(this.page)
          } else {
            this.$message({
              type: 'error',
              message: '集中器信息查询失败,请刷新页面!',
              duration: 5 * 1000
            })

          }

          this.loading = false
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '集中器信息查询失败,请刷新页面!',
            duration: 5 * 1000
          })
          this.loading = false
          console.log(error)
        })
      }, myCheck(...values) { /* true为空 */
        if (typeof values === undefined || values === null || values === '') return true
        let ret = true
        for (let i = 0; i < values.length; i++) {
          ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
          if (ret === false) break
        }
        return ret
      },
      collectionModify() {
        collectionModify(this.form).then(response => {
          if (response.code === 200) {
            this.disabled = true
            /* 点击改变按钮状态*/
            this.loading = true
            const data = response
            console.log(data)
            this.form = {
              /* 实体对应表单数据*/
              id: '',
              name: '',
              code: '',
              note: '',
              enabled: 1,
              icon: ''
            }
            this.success('修改')
            /* this.page.current  = this.page.pages;*/
          } else {

            this.$message({
              type: 'error',
              message: '修改集中器信息失败!',
              duration: 5 * 1000
            })
          }
          /*this.reset()
          this.page.current = parseInt('1')*/
          this.dialogFormVisible = false
          this.resetForm('form')
          this.page.size = 10
          this.selectCollection()
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '修改集中器信息失败!',
            duration: 5 * 1000
          })
          this.reset()
          this.page.current = parseInt('1')
          this.dialogFormVisible = false
          this.resetForm('form')
          this.selectCollection()
          this.loading = false
          console.log(error)
        })
      },
      rowClick(row) { /* 行点击事件*/
        /* this.currentRow = row.index
        /!* row中默认没有保存下标的属性,自定义*!/
        console.log('当前行数据id = ' + row.id)
        console.log('当前索引 = ' + row.index)

        console.log(this.form)*/
        console.log(row)
        this.form.name = row.name
        this.form.id = row.id
        this.form.code = row.code
        this.form.enabled = row.enabled
        this.form.icon = row.icon
        this.form.note = row.note
      },
      selectedHighlight({row, rowIndex}) {
        if (rowIndex === this.currentRow) {
          return 'background: pink'
        }
        return ''
      },
      restFormData() {
        this.currentRow = ''
        this.doType = ''
        /* this.form = {
          /!* 实体对应表单数据*!/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: '',
          icon: ''
        }*/
      },
      clearInput() { /* 清空搜索框*/
        this.condition = {}
        this.selectCollection()
      },
      /* addCollection() { /!* 添加集中器*!/
        this.disabled = true
        /!* 点击改变按钮状态*!/
        this.loading = true
        addCollection(this.form).then(response => {
          const data = response
          console.log(data)
          this.success('添加')
          /!* this.page.current  = this.page.pages;*!/
          this.reset()
          this.page.current = parseInt('1')
          this.dialogFormVisible = false
          this.resetForm('form')
          this.selectCollection()
        }).catch(error => {
          this.loading = false
          this.dialogFormVisible = false
          this.doType = ''
          console.log(error)
        })
      },*/
      success(type) { /* 成功提示*/
        /* this.$notify({
          title: ' 成功',
          message: type + '集中器信息成功',
          type: 'success',
          duration: 2000
        })*/
        this.$message({
          message: type + '集中器信息成功',
          type: 'success',
          duration: 5 * 1000
        })
      },
      handleSizeChange(size) { /* 改变条数*/
        this.form = {
          /* 实体对应表单数据*/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: 1,
          icon: ''
        }
        this.page.size = size
        this.selectCollection()
      },
      handleCurrentChange(val) { /* 改变页数*/
        this.form = {
          /* 实体对应表单数据*/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: 1,
          icon: ''
        }
        this.page.current = val
        this.selectCollection()
      }
    }

  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .collection-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        font-size: 14px;
        flex-direction: column;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .collection-manage-head {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            button {
                margin-left: 10px;
            }
            .collection-manage-condition-box {
                font-size: 14px;
                height: 50px;
                display: flex;
                align-items: center;
                padding-top: 15px;
                padding-left: 20px;
                box-sizing: border-box;
                button {
                    margin-left: 10px;
                }

            }
            .meter-manage-condition-box-label {
                width: 180px;
            }
            .op-box {
                padding-left: 0.5rem;
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
                /*padding-left: 1%;

                padding-bottom: 15px;*/
            }
        }
        .collection-manage-table-box {
            /* overflow: auto;
             max-height: 320px;
             height: auto;
             width: auto;
             display: block;
             align-items: center;*/

        }

        .el-table .warning-row {
            background: oldlace;
        }

        .div-hr {
            height: 0.1rem;
            background-color: #dedede;
            margin-bottom: 0.5rem;
        }
        .dialog-hr {
            height: 0.0625rem;
            background-color: #dedede;
        }
        .collection-manage-page-box {
            height: 45px;
            display: flex;

            justify-content: center;
            align-items: center;
        }

    }

    /*#pagination {
        margin: 0 auto -50px;
        padding: 0 20px;
    }*/

    /* ::-webkit-scrollbar { !*滚动条整体样式*!
         width: 6px; !*高宽分别对应横竖滚动条的尺寸*!
         height: 6px;
     }

     ::-webkit-scrollbar-thumb { !*滚动条里面小方块*!
         border-radius: 5px;
         -webkit-box-shadow: inset 0 0 5px rgba(210, 210, 210, 210);
         background: rgba(210, 210, 210, 210);
     }

     ::-webkit-scrollbar-track { !*滚动条里面轨道*!
         -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 255);
         border-radius: 0;
         background: rgba(255, 255, 255, 255);
     }
 */
</style>
<!--<style>
    .collection-manage-box .el-dialog__body {
        border-top: 1px solid #dedede;
        border-bottom: 1px solid #dedede;

    }

</style>-->
<!--
<style scoped>
    /*#pagination {
        margin: 0 auto -50px;
        padding: 0 20px;
    }*/

    #header {
        /*display: block*/
        font-size: 14px;
        height: 60px;
        display: flex;
        align-items: center;
        padding-top: 15px;
        padding-left: 20px;
        box-sizing: border-box;

    }

    #list {
        overflow: auto;
        max-height: 320px;
        height: auto;
        width: auto;
        display: block;
        align-items: center;

    }

    .op-box {
        padding-left: 20px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    #list::-webkit-scrollbar { /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }

    #list::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(176, 176, 176, 176);
        background: rgba(176, 176, 176, 176);
    }

    #list::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 255);
        border-radius: 0;
        background: rgba(255, 255, 255, 255);
    }

    .col-table {
        flex: 1;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .div-hr {
        height: 1px;
        background-color: #dedede;
    }

    #pagination {
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>-->
